import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button 
      onClick={toggleLanguage} 
      className="absolute top-6 left-6 z-50 flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-md border border-slate-200 hover:bg-slate-100 text-slate-700 rounded-full text-sm font-bold transition-all shadow-sm"
      dir="ltr" // الزر يظل دائماً بنفس الاتجاه لكي لا يتشوه
    >
      <Globe className="w-4 h-4 text-indigo-500" />
      {language === 'ar' ? 'Français' : 'العربية'}
    </button>
  );
};

export default LanguageToggle;